import React, { Component } from "react";
import PropTypes from "prop-types";
import "./audio.css";
import "antd/dist/antd.css";
import AudioEditor from "./audioEditor";
import clickEdit from "../atlas/CmClickEdit"  //点击编辑调用原来的
import { Row, Col, Checkbox, Tooltip, Modal, Icon } from "antd";
const viewNum = <span>浏览量</span>;
const likeNum = <span>点赞量</span>;
const transmitNum = <span>转发量</span>;

export default class AudioList extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#0050B3",
  };
  // 静态类型分析
  static propTypes = {
    coverPic: PropTypes.string.isRequired, //图片
    title: PropTypes.string.isRequired, //标题
    desc: PropTypes.string.isRequired, //描述
    source: PropTypes.string.isRequired, //来源
    status: PropTypes.number.isRequired, //状态
    newTime: PropTypes.string.isRequired, //时间
    viewNum: PropTypes.number.isRequired, //浏览量
    likeNum: PropTypes.number.isRequired, //点赞量
    forwardNum: PropTypes.number.isRequired, //转发量
    mediaFusionAudio: PropTypes.string.isRequired, //音频时长
    VideoName: PropTypes.string.isRequired, //音频name
    mediaFusionAudioURL: PropTypes.string.isRequired, //音频路径
    mediaFusionId: PropTypes.number.isRequired, //删除id
    id: PropTypes.number.isRequired, //删除id
    type: PropTypes.number.isRequired, //删除type
  };
  constructor(props) {
    super(props);
    this.state = {
      bigImgVisible: false,
      desc: "",
    };
  }
  // 预览大图
  showModal = () => {
    this.setState({
      bigImgVisible: true,
      desc: this.props.desc,
    });
  };
  // 点击编辑拿到父组件的方法
  showModal2 = () => {
    // this.props.getAllReports();
    // this.props.filterCheckedColumns();
    // this.props.getFindIds(this.props.id);
    // this.refs.editor.showModal();
    clickEdit.gotoPage(this.props.type, this.props.id);
  };
  bigImgOk = (e) => {
    console.log(e);
    this.setState({
      bigImgVisible: false,
    });
  };

  bigImgCancel = (e) => {
    console.log(e);
    this.setState({
      bigImgVisible: false,
    });
  };

  // 删除
  showModa3 = () => {
    this.setState({
      visible3: true,
    });
  };
  delOk = (e) => {
    this.props.myClick(this.props.id);
    this.setState({
      visible3: false,
    });
  };

  delCancel = (e) => {
    console.log(e);
    this.setState({
      visible3: false,
    });
  };
  render() {
    let status = this.props.status;
    let statusJudge;
    // 判断删除、撤回状态
    if (status === 2) {
      statusJudge = (
        <Col
          span={2}
          style={{ textAlign: "center", cursor: "pointer", color: "#999" }}
        >
          <span
            style={{ color: "#337ab7" }}
            onClick={this.recall}
          >
            撤回
          </span>
        </Col>
      );
    } else {
      statusJudge = (
        <Col
          span={2}
          style={{ textAlign: "center", cursor: "pointer", color: "#999" }}
        >
          <div
            style={{
              color: `${this.props.newSecondSelectColor}`,
              marginBottom: "10px",
              cursor: "pointer",
            }}
            onClick={this.showModal2}
          >
            <span style={{ color: "#337ab7" }}>
              编辑
            </span>
          </div>
          {/* 编辑组件 */}
          <AudioEditor
            ref="editor"
            coverPic={this.props.coverPic}
            VideoName={this.props.VideoName}
            desc={this.props.desc}
            title={this.props.title}
            labelNames={this.props.labelNames}
            columnList={this.props.columnList}
            userDate={this.props.userDate}
            filterColumn={this.props.filterColumn}
            myAlter={(txtText) => this.alter(txtText)}
            getAllReports={() => this.props.getAllReports()}
            getEditorColumnLists={() => this.props.getEditorColumnLists()}
            editorColumnList={this.props.editorColumnList}
          />
          <div style={{ color: "red" }} onClick={this.showModa3}>
            <span style={{ color: "red" }}>
              删除
            </span>
          </div>
          <Modal
            title="信息"
            visible={this.state.visible3}
            onOk={this.delOk}
            onCancel={this.delCancel}
            centered
            width="300px"
          >
            确定删除吗？
          </Modal>
        </Col>
      );
    }
    return (
      <div
        style={{
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #ccc",
            padding: "5px",
            marginTop: "5px",
          }}
        >
          <Row
            justify="start"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Checkbox
                checked={this.props.checked} //拿到父组件内部子组件的checked方法
                onClick={(e) => {
                  this.props.ItemClick(); //点击子组件时拿到父组件内部子组件的方法
                }}
              />
              <div
                className="atlasListPic"
                style={{ marginLeft: "20px", position: "relative" }}
                onClick={this.showModal}
              >
                <img src={this.props.coverPic} alt="" />
                <div
                  style={{
                    width: "40px",
                    height: "20px",
                    color: "#fff",
                    backgroundColor: "#00000099",
                    lineHeight: "20px",
                    textAlign: "center",
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                  }}
                >
                  {this.props.mediaFusionAudio}
                </div>
              </div>
              <div style={{ display: "flex" }} onClick={this.showModal}>
                <div style={{ margin: "0px 20px" }}>
                  <Icon type="check-circle" theme="filled" />
                </div>
                <div>
                  <div className="mf-title">{this.props.title}</div>
                  <div className="audioTitle">{this.state.desc}</div>
                </div>
              </div>
            </Col>
            <div className="viewBigImage">
              <Modal
                centered
                title={this.props.title}
                visible={this.state.bigImgVisible}
                onOk={this.bigImgOk}
                onCancel={this.bigImgCancel}
                footer={null}
                width="620px"
                bodyStyle={{ height: "530px", padding: 0 }} //modal自带内边距
              >
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      width: "600px",
                      height: "555px",
                      margin: "10px auto",
                    }}
                  >
                    <img
                      style={{
                        width: "600px",
                        height: "525px",
                        objectFit: "contain",
                        maxHeight: "100%",
                      }}
                      src={this.props.coverPic}
                      alt=""
                    />
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      right: "210px",
                    }}
                  >
                    <audio
                      style={{ width: "200px", height: "20px" }}
                      src={this.props.mediaFusionAudioURL}
                      controls
                    />
                  </div>
                </div>
              </Modal>
            </div>
            <Col span={2} style={{ textAlign: "center", color: "#999" }}>
              {this.props.source ? "转载" : "原创"}
            </Col>
            <Col
              span={2}
              style={{ textAlign: "center", color: "#aaa", overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap" }}
            >
              {/* 用逗号连接 */}
              {this.props.labelNames.join(",")}
            </Col>
            <Col span={2} style={{ textAlign: "center", color: "#999" }}>
              {(() => {
                switch (this.props.status) {
                  case "1": return "暂存"; break;
                  case "2": return "已发布"; break;
                  case "3": return "撤稿"; break;
                  case "4": return "发布失败"; break;
                  case "5": return "发布中"; break;
                  default: return null;
                }
              }
              )()}
            </Col>
            <Col span={2} style={{ textAlign: "center", color: "#999" }}>
              {this.props.newTime}
            </Col>
            <Col span={2} style={{ textAlign: "center", color: "#999" }}>
              <div style={{ marginLeft: "5px 0px" }}>
                <span>
                  <Tooltip placement="left" title={viewNum}>
                    <Icon type="play-circle" theme="filled" />
                  </Tooltip>
                </span>
                <span style={{ marginLeft: "5px" }}>{this.props.viewNum}</span>
              </div>
              <div style={{ margin: "5px 0px" }}>
                <span>
                  <Tooltip placement="left" title={likeNum}>
                    <Icon type="heart" theme="filled" />
                  </Tooltip>
                </span>
                <span style={{ marginLeft: "5px" }}>{this.props.likeNum}</span>
              </div>
              <div style={{ margin: "5px 0px" }}>
                <span>
                  <Tooltip placement="left" title={transmitNum}>
                    <Icon type="share-alt" />
                  </Tooltip>
                </span>
                <span style={{ marginLeft: "5px" }}>
                  {this.props.forwardNum}
                </span>
              </div>
            </Col>
            {statusJudge}
          </Row>
        </div>
      </div>
    );
  }
  //  修改描述
  alter(txtText) {
    this.setState({
      desc: txtText,
    });
  }
  // 点击撤回
  recall = () => {
    this.props.getRecall(this.props.id);
  };
}
